module.exports = __webpack_public_path__ + "3b43397ff80e8f474f47ea90e863dbf9.png";


//////////////////
// WEBPACK FOOTER
// ./markup/img/el-1.png
// module id = 1072
// module chunks = 0